export default "__VITE_ASSET__Zd8q9TdB__"